import React, { useEffect, useState } from "react";
import FormInputText from "../../Component/FormInputText";
import {
  FormInputDropdown,
  generateSingleOptions,
} from "../../Component/FormComponent/FormInputDropdown";
import { Controller, useForm } from "react-hook-form";
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  FormLabel,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Container } from "@mui/system";

import {
  optionsUserCategory,
  optionsUserType,
} from "../../select-options/options";
import { green } from "@mui/material/colors";
import styled from "@emotion/styled";
import { Link, useNavigate } from "react-router-dom";
import { useRegisterUserMutation } from "../../services/apiSlice";
import Swal from "sweetalert2";
import { Fade } from "react-awesome-reveal";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";

const defaultValues = {
  user_type: "",
  user_categories: "",
  mobile_number: "",
  first_name: "",
  last_name: "",
  address: "",
  zip_code: "",
  company_name: "",
  password: "",
  company_website: "",
  confirm_password: "",
};
//
const SignUp = () => {
  const [errorNumber, setErrorNumber] = useState("");
  const methods = useForm({ defaultValues: defaultValues });
  const {
    handleSubmit,
    reset,
    control,
    setValue,
    watch,
    register,
    getValues,

    formState: { errors },
  } = methods;
  const navigate = useNavigate();
  const watchShowOthers = watch("user_type", false);

  const [registerUser, { data, isError, error }] = useRegisterUserMutation();
  useEffect(() => {
    console.log("userPayload", data, error);
    if (data?.success === true) {
      // success message
      Swal.fire(
        "Awesome!",
        ` You're successfully registered! and ${data?.message}`,
        "success"
      ).then((result) => {
        if (result.isConfirmed || result.isDismissed) {
          navigate(`/login`);
        }
      });
    } else if (isError) {
      //error
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.data?.message,
      });
    } else if (data?.success === false) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data?.message,
      });
    }
  }, [data, isError]);
  const onSubmit = async (data) => {
    // const userData = {
    //   first_name: data.first_name,
    //   surname: data.surname,
    //   other_name: data.other_name,
    //   password: data.password,
    //   email: data.email,
    //   confirm_password: data.confirm_password,

    //   mobile_number: selectedCountry.phonecode + data.mobile_number,
    //   country: data.country,
    // };
    console.log("register", " data.mobile_number_phone_code", data);
    try {
      await registerUser(data).unwrap();
    } catch (error) {
      if (isError) {
        //error
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.data.message,
        });
      }
      console.log("error", error?.data?.message);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error?.data?.message,
      });
    }
  };
  const handleValidate = (value) => {
    const isValid = isValidPhoneNumber(value);
    console.log({ isValid });
    if (!isValid) {
      // error = 'Number not valid'

      setErrorNumber("Not a valid number please try again later!!");
    }
    return isValid;
  };

  return (
    <>
      <Fade cascade>
        <Container>
          <Box maxWidth={"md"} className="min-h-screen" sx={{ mt: 10 }}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Paper
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gridRowGap: "20px",
                  padding: "20px",
                  // margin: "30px 300px",
                }}
                sx={{
                  width: "md",
                }}
              >
                <Typography
                  variant="h1"
                  component="h2"
                  className="text-3xl uppercase font-extrabold text-center py-2 md:py-4 "
                  sx={{ textAlign: "center" }}
                >
                  Create an account
                </Typography>
                <FormControl
                  error={Boolean(errors.user_type)}
                  // helperText={errors.user_type?.message}
                  size={"small"}
                >
                  <InputLabel> What best describes you?</InputLabel>

                  <Controller
                    rules={{
                      required: "Please select   What best describes you?",
                    }}
                    render={({ field }) => (
                      <Select {...field}>
                        {generateSingleOptions(optionsUserType)}
                      </Select>
                    )}
                    name="user_type"
                    control={control}
                  />
                  <FormHelperText>{errors.user_type?.message}</FormHelperText>
                </FormControl>
                <FormControl
                  error={Boolean(errors.user_categories)}
                  // helperText={errors.user_type?.message}
                  size={"small"}
                >
                  <InputLabel> What service do you offer?</InputLabel>

                  <Controller
                    rules={{
                      required: "Please select   the categories you belong to?",
                    }}
                    render={({ field }) => (
                      <Select {...field}>
                        {generateSingleOptions(optionsUserCategory)}
                      </Select>
                    )}
                    name="user_categories"
                    control={control}
                  />
                  <FormHelperText>
                    {errors.user_categories?.message}
                  </FormHelperText>
                </FormControl>
                <TextField
                  // id="outlined-basic"
                  name="first_name"
                  label="First Name"
                  variant="outlined"
                  size="small"
                  fullWidth
                  {...register("first_name", {
                    required: "First name is required",
                    minLength: {
                      value: 3,
                      message: "First name should have at-least 3 characters.",
                    },
                    pattern: {
                      value: /^[a-zA-Z]{3,}$/,
                      message: "First name should contain only characters.",
                    },
                  })}
                  error={Boolean(errors.first_name)}
                  helperText={
                    errors.first_name && errors.first_name.type === "required"
                      ? errors.first_name.message
                      : errors.first_name &&
                        errors.first_name.type === "pattern"
                      ? errors.first_name.message
                      : errors.first_name &&
                        errors.first_name.type === "minLength" &&
                        errors.first_name.message
                  }
                />
                <TextField
                  // id="outlined-basic"
                  label="Last Name"
                  variant="outlined"
                  fullWidth
                  size={"small"}
                  name="last_name"
                  {...register("last_name", {
                    required: "Last name is required",
                    minLength: {
                      value: 3,
                      message: "Last name  should have at-least 3 characters.",
                    },
                    pattern: {
                      value: /^[a-zA-Z]{3,}$/,
                      message: "Last name name should contain only characters.",
                    },
                  })}
                  error={Boolean(errors.last_name)}
                  helperText={
                    errors.last_name && errors.last_name.type === "required"
                      ? errors.last_name.message
                      : errors.last_name && errors.last_name.type === "pattern"
                      ? errors.last_name.message
                      : errors.last_name &&
                        errors.last_name.type === "minLength" &&
                        errors.last_name.message
                  }
                />
                <TextField
                  label="E-mail"
                  variant="outlined"
                  fullWidth
                  name="email"
                  size={"small"}
                  {...register("email", {
                    required: "Email is Required",
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: "Invalid email address",
                    },
                  })}
                  error={Boolean(errors.email)}
                  helperText={
                    errors.email && errors.email.type === "required"
                      ? errors.email.message
                      : errors.email &&
                        errors.email.type === "pattern" &&
                        errors.email.message
                  }
                />
                <FormControl error={Boolean(errors.mobile_number)}>
                  <Controller
                    name="mobile_number"
                    control={control}
                    rules={{
                      required: "mobile number is Required",

                      minLength: {
                        value: 10,
                        message:
                          "Mobile number should have at-least 11 number.",
                      },
                      maxLength: {
                        value: 13,
                        message:
                          "Mobile number should not be more than 13  numbers.",
                      },
                      pattern: {
                        value:
                          /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
                        message: "Invalid mobile number no",
                      },

                      validate: {
                        validate: (value) => {
                          handleValidate(value);
                        },
                      },
                    }}
                    render={({ field: { onChange, value } }) => (
                      // this is where our react-phone-number-input will go
                      <PhoneInput
                        value={value}
                        onChange={onChange}
                        defaultCountry="US"
                        id="phone-input"
                        country="US"
                        placeholder="Enter phone number"
                        // onlyCountries={["us"]}

                        className="border-4 py-1 px-2  border-gray-300"
                      />
                    )}
                  />{" "}
                  <FormHelperText>
                    {errors.mobile_number?.message}
                  </FormHelperText>
                  <FormHelperText>{errorNumber}</FormHelperText>
                </FormControl>

                {/* <TextField
                  name="mobile_number"
                  label="Mobile Number"
                  variant="outlined"
                  fullWidth
                  size={"small"}
                  {...register("mobile_number", {
                    required: "mobile number is Required",
                    valueAsNumber: true,
                    minLength: {
                      value: 14,
                      message: "Mobile number should have at-least 11 number.",
                    },
                    maxLength: {
                      value: 13,
                      message:
                        "Mobile number should not be more than 13  numbers.",
                    },
                    pattern: {
                      value:
                        /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/,
                      message: "Invalid mobile number no",
                    },
                  })}
                  error={Boolean(errors.mobile_number)}
                  helperText={
                    errors.mobile_number &&
                    errors.mobile_number.type === "required"
                      ? errors.mobile_number.message
                      : errors.mobile_number &&
                        errors.mobile_number.type === "minLength"
                      ? errors.mobile_number.message
                      : errors.mobile_number &&
                        errors.mobile_number.type === "pattern"
                      ? errors.mobile_number.message
                      : errors.mobile_number &&
                        errors.mobile_number.type === "maxLength" &&
                        errors.mobile_number.message
                  }
                /> */}
                <TextField
                  name="address"
                  label="Address"
                  variant="outlined"
                  fullWidth
                  size={"small"}
                  {...register("address", {
                    required: "Please specify your residential address",
                  })}
                  error={Boolean(errors.address)}
                  helperText={errors.address?.message}
                />
                <TextField
                  name="zip_code"
                  label="Zip"
                  variant="outlined"
                  fullWidth
                  size={"small"}
                  {...register("zip_code", {
                    required: "Please specify your zip or postal code",
                    maxLength: {
                      value: 5,
                      message: "Zip code should not be more than 5  numbers.",
                    },
                    minLength: {
                      value: 5,
                      message: "Zip code should not be less than 5  numbers.",
                    },
                  })}
                  error={Boolean(errors.zip_code)}
                  helperText={
                    errors.zip_code && errors.zip_code.type === "required"
                      ? errors.zip_code.message
                      : errors.zip_code && errors.zip_code.type === "minLength"
                      ? errors.zip_code.message
                      : errors.zip_code && errors.zip_code.type === "pattern"
                      ? errors.zip_code.message
                      : errors.zip_code &&
                        errors.zip_code.type === "maxLength" &&
                        errors.zip_code.message
                  }
                />
                {watchShowOthers === "bussiness" && (
                  <>
                    <TextField
                      name="company_name"
                      label="Company Name"
                      variant="outlined"
                      fullWidth
                      size={"small"}
                      {...register("company_name", {
                        required:
                          "Please provide your company name is required.",
                      })}
                      error={Boolean(errors.company_name)}
                      helperText={errors.company_name?.message}
                    />
                    <TextField
                      name="company_website"
                      label="Company Website"
                      variant="outlined"
                      fullWidth
                      {...register("company_website")}
                      // error={Boolean(errors.company_name)}
                      // helperText={errors.company_name?.message}
                    />
                  </>
                )}
                <TextField
                  name="password"
                  label="Password"
                  variant="outlined"
                  fullWidth
                  size={"small"}
                  type={"password"}
                  {...register("password", {
                    required: "password  is Required",
                    minLength: {
                      value: 8,
                      message: "Password should have at-least 8 characters.",
                    },
                    pattern: {
                      value:
                        /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                      message:
                        "The password must contain atleast one uppercase, one lowercase and one special characters",
                    },
                  })}
                  error={Boolean(errors.password)}
                  helperText={
                    errors.password && errors.password.type === "required"
                      ? errors.password.message
                      : errors.password && errors.password.type === "minLength"
                      ? errors.password.message
                      : errors.password &&
                        errors.password.type === "pattern" &&
                        errors.password.message
                  }
                />
                <TextField
                  name="confirm_password"
                  label="Confirm password"
                  variant="outlined"
                  fullWidth
                  size={"small"}
                  type={"password"}
                  {...register("confirm_password", {
                    required: "confirm password  is Required",
                    minLength: {
                      value: 8,
                      message:
                        "confirm password should have at-least 8 characters.",
                    },
                    pattern: {
                      value:
                        /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                      message:
                        "The confirm password must contain atleast one uppercase, one lowercase and one special characters",
                    },
                    validate: (value) => {
                      // const { password } = getValue()
                      return (
                        value === getValues("password") ||
                        "Comfirm password does not match with password!"
                      );
                    },
                  })}
                  error={Boolean(errors.confirm_password)}
                  helperText={
                    errors.confirm_password &&
                    errors.confirm_password.type === "required"
                      ? errors.confirm_password.message
                      : errors.confirm_password &&
                        errors.confirm_password.type === "minLength"
                      ? errors.confirm_password.message
                      : errors.confirm_password &&
                        errors.confirm_password.type === "pattern"
                      ? errors.confirm_password.message
                      : errors.confirm_password &&
                        errors.confirm_password.type === "validate" &&
                        errors.confirm_password.message
                  }
                />
                <FormGroup
                  error={Boolean(errors.tnc)}
                  style={{ display: "block", marginTop: "17px" }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="tnc"
                        {...register("tnc", {
                          required: "please aggre our terms and condtions",
                        })}
                      />
                    }
                    label="I agree all terms and conditions"
                  />
                </FormGroup>
                <FormHelperText style={{ color: "#d32f2f" }}>
                  {errors.tnc?.message}
                </FormHelperText>
                <div className="clearfix"></div>
                <Button
                  variant="contained"
                  type="submit"
                  className="hover:bg-green-300"
                  sx={{
                    color: "white",
                    background: green[600],
                    // width: "40%",
                    // mx: 30,
                    textAlign: "center",
                    placeItems: "center",
                  }}
                >
                  create new account
                </Button>
                <Typography
                  variant="p"
                  component="p"
                  className="text-base  font-normal text-center py-2 md:py-4 "
                  sx={{ textAlign: "center" }}
                >
                  Alrealdy have an account?{" "}
                  <Link to={"/login"}>
                    {" "}
                    <Typography
                      variant="span"
                      component="span"
                      className="text-blue-500 text-lg  mx-2 font-normal text-center py-2 md:py-4 "
                      sx={{ textAlign: "center" }}
                    >
                      Login
                    </Typography>{" "}
                  </Link>
                </Typography>
              </Paper>
            </form>
          </Box>
        </Container>
      </Fade>
    </>
  );
};

export default SignUp;
